export function entriesToObject(obj, [key, value]) {
  obj[key] = value
  return obj
}
